const mediaGalleryItemTag = 'OWC-MEDIA-GALLERY-ITEM';
const genericImagetag = 'OWC-GENERIC-IMAGE';
const videoPlayerTag = 'OWC-VIDEO-PLAYER';
const acceptNodes = [mediaGalleryItemTag, genericImagetag, videoPlayerTag];

export type Tree = {
  id: string;
  childComponents: Tree;
}[];

const setImgHeight = (img: HTMLElement) => {
  img.classList.add('owc-generic-image__fixed-height');
  img.style.setProperty('height', 'var(--mediaGalleryRowHeight)');
};

const handleImage = (node: HTMLElement) => {
  let img = node.shadowRoot?.querySelector('img')!;
  if (!img) {
    const slot = node.shadowRoot?.querySelector('slot');
    slot?.addEventListener(
      'slotchange',
      () => {
        img = node.shadowRoot?.querySelector('img')!;
        if (img) {
          setImgHeight(img);
        }
      },
      { once: true },
    );
  } else {
    setImgHeight(img);
  }
};

const acceptNode = function(node: Element) {
  if (acceptNodes.includes(node.tagName)) {
    return NodeFilter.FILTER_ACCEPT;
  }
  return NodeFilter.FILTER_REJECT;
};

export const parseTree = (root: Element) => {
  const tree: Tree = [];
  const treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
    acceptNode,
  });

  let currentNode = treeWalker.currentNode as HTMLElement;

  while (currentNode) {
    const node = currentNode;
    if (node !== root) {
      const id = currentNode.getAttribute('component-id');
      if (id) {
        const data = { id, childComponents: [] };
        const foundParent = tree.find(item => item.id === node.parentElement?.getAttribute('component-id'));
        if (foundParent) {
          foundParent.childComponents.push(data);
        } else {
          tree.push(data);
        }
      } else {
        throw new Error('Invalid Media Gallery markup');
      }
    }
    if (node.tagName === mediaGalleryItemTag) {
      node.style.setProperty('height', 'var(--mediaGalleryRowHeight)');
    }
    if (node.tagName === genericImagetag) {
      handleImage(node);
    }
    if (node.tagName === videoPlayerTag) {
      const observer = new MutationObserver(() => {
        handleImage(node);
        observer.disconnect();
      });
      const config = { childList: true };
      let shadowRoot: ShadowRoot | null | undefined = null;

      if (node.id.includes('-target')) {
        shadowRoot = node.firstElementChild?.shadowRoot;
      } else {
        shadowRoot = node.shadowRoot;
      }

      if (shadowRoot) {
        observer.observe(shadowRoot, config);
      }
    }
    currentNode = treeWalker.nextNode() as HTMLElement;
  }

  return tree;
};
